<!--系统配置 分类管理 设置加点-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-button size="medium" @click="openAdd" style="margin-top: 20px">新增加点</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="margin-top: 20px">
        <el-table border stripe :data="tableData">
          <el-table-column type="index"></el-table-column>
          <el-table-column prop="CONTENT" label="价格区间"></el-table-column>
          <el-table-column prop="ADD_POINT" label="点数(%)"></el-table-column>
          <el-table-column prop="IS_DEFAULT" label="是否为默认加点">
            <template slot-scope="scope">
              {{ showBase[scope.row.IS_DEFAULT] }}
            </template>
          </el-table-column>
          <el-table-column prop="IS_DEFAULT" label="是否为默认加点">
            <template slot-scope="scope">
              <el-button type="text" @click="editPoint(scope.row)">修改</el-button>
              <el-button type="text" @click="deletePoint(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <!-- 新增加点 -->
    <el-dialog title="新增加点" center :visible.sync="addFormVisible" width="400px">
      <el-form :model="addForm" ref="addForm">
        <el-form-item label="加点：" :label-width="formLabelWidth">
          <el-input v-model="addForm.ADD_POINT"></el-input>
        </el-form-item>
        <el-form-item label="是否为默认：" :label-width="formLabelWidth">
          <el-radio v-model="radio" label="1">是</el-radio>
          <el-radio v-model="radio" label="0">否</el-radio>
        </el-form-item>
        <el-form-item label="价格区间：" :label-width="formLabelWidth" v-show="radio == 0">
          <el-col :span="11">
            <el-form-item>
              <el-input style="width: 100%" v-model="addForm.MIN_PRICE"></el-input>
            </el-form-item>
          </el-col>
          <el-col class="line" :span="2">--</el-col>
          <el-col :span="11">
            <el-form-item>
              <el-input style="width: 100%" v-model="addForm.MAX_PRICE"></el-input>
            </el-form-item>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 修改加点 -->
    <el-dialog title="修改加点" center :visible.sync="editFormVisible" width="400px">
      <el-form :model="editForm" ref="editForm">
        <el-form-item label="加点：" :label-width="formLabelWidth">
          <el-input v-model="editForm.ADD_POINT" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button @click="submitEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getAddPointFun, addPointFun, editPointFun, deletePointFun,
} from 'api/systemSetting';
import validation from '@/assets/common/validation';

export default {
  data() {
    return {
      tableData: [],
      showBase: ['否', '默认加点'],
      addForm: {},
      addFormVisible: false,
      formLabelWidth: '100px',
      radio: '0',
      editFormVisible: false,
      editForm: {},
    };
  },
  methods: {
    queryData() {
      const params = {
        CATALOG_ID: sessionStorage.getItem('kindId'),
      };
      getAddPointFun(params).then((result) => {
        this.tableData = result;
        result.map((item) => Object.assign(item, { CONTENT: `${item.MIN_PRICE}-${item.MAX_PRICE}` }));
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    openAdd() {
      this.addFormVisible = true;
    },
    submitAdd() {
      if (!this.addForm.ADD_POINT || !this.addForm.MIN_PRICE || !this.addForm.MAX_PRICE) {
        this.$message.show({ text: '请输入加点和价格区间', type: 'warning' });
        return false;
      }
      const reg = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      if (!reg.test(this.addForm.ADD_POINT)) {
        this.$message.show({ text: '请输入正确的加点', type: 'warning' });
        return false;
      }
      if (!validation.价格正数0验证(this.addForm.MIN_PRICE)) {
        this.$message.show({ text: '请输入正确的最低区间', type: 'warning' });
        return false;
      }
      if (!validation.价格正数0验证(this.addForm.MAX_PRICE)) {
        this.$message.show({ text: '请输入正确的最高区间', type: 'warning' });
        return false;
      }
      const params = {
        CATALOG_ID: sessionStorage.getItem('kindId'),
        IS_DEFAULT: this.radio,
        ADD_POINT: this.addForm.ADD_POINT,
      };
      if (this.addForm.MIN_PRICE) {
        params.MIN_PRICE = this.addForm.MIN_PRICE;
      }
      if (this.addForm.MAX_PRICE) {
        params.MAX_PRICE = this.addForm.MAX_PRICE;
      }
      addPointFun(params).then((result) => {
        this.$message.show({ text: '新增成功', type: 'success' });
        this.addFormVisible = false;
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    close() {
      this.addFormVisible = false;
    },
    editPoint(row) {
      this.editFormVisible = true;
      this.editForm = row;
    },
    submitEdit() {
      const params = {
        CATALOG_ID: sessionStorage.getItem('kindId'),
        ADD_POINT: this.editForm.ADD_POINT,
        ADD_POINT_ID: this.editForm.ID,
        IS_DEFAULT: this.editForm.IS_DEFAULT,
      };
      if (!this.editForm.ADD_POINT) {
        this.$message.show({ text: '请输入加点', type: 'warning' });
        return false;
      }
      editPointFun(params).then((result) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.editFormVisible = false;
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    deletePoint(row) {
      const params = {
        ADD_POINT_ID: row.ID,
      };
      deletePointFun(params).then((result) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
  created() {
    this.queryData();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/systemSetting/kindAddPoint.vue